module.exports = __webpack_public_path__ + "img/payment-amex.7fddf79b.png";